@if (isOffline()) {
  <skk-banner type="error" class="offline-banner">
    <span i18n="@@app.offline.message">No internet connection. Some features may not work.</span>
  </skk-banner>
}
<skk-version-banner class="subscription-banner" />
@if (hideTopbar() === false) {
  <skk-trial-banner class="subscription-banner" />
}
<main class="main-container">
  <div class="horizontal-content">
    @if (hideSidebar() === false) {
      <skk-sidebar />
    }
    <div class="vertical-content">
      @if (hideTopbar() === false) {
        <skk-topbar />
      }
      <div class="page-content">
        <router-outlet />
      </div>
    </div>
  </div>
</main>
